// audio-player.js
// Custom audio player with play/pause, seek, volume and mute.
// When multiple players are present, starting one pauses all the others.
document.addEventListener("DOMContentLoaded", function () {
  try {
    var players = document.querySelectorAll("[data-audio-player]");

    if (players.length === 0) {
      return;
    }

    // Keep a reference to every audio element so a playing one can stop the rest.
    var allAudios = [];

    function formatTime(seconds) {
      if (!isFinite(seconds) || seconds < 0) {
        seconds = 0;
      }
      var minutes = Math.floor(seconds / 60);
      var secs = Math.floor(seconds % 60);
      return minutes + ":" + (secs < 10 ? "0" : "") + secs;
    }

    players.forEach(function (player) {
      var audio = player.querySelector("audio");

      if (!audio) {
        return;
      }

      allAudios.push(audio);

      var playBtn = player.querySelector("[data-play]");
      var muteBtn = player.querySelector("[data-mute]");
      var seek = player.querySelector("[data-seek]");
      var volume = player.querySelector("[data-volume]");
      var current = player.querySelector("[data-current]");
      var remaining = player.querySelector("[data-remaining]");

      function setSeekFill() {
        var pct = audio.duration ? (audio.currentTime / audio.duration) * 100 : 0;
        seek.value = pct;
        seek.style.setProperty("--progress", pct + "%");
      }

      function setVolumeFill() {
        var pct = (audio.muted ? 0 : audio.volume) * 100;
        volume.value = audio.muted ? 0 : audio.volume;
        volume.style.setProperty("--progress", pct + "%");
      }

      // Metadata loaded: we now know the duration.
      audio.addEventListener("loadedmetadata", function () {
        setSeekFill();
        current.textContent = formatTime(0);
        remaining.textContent = "-" + formatTime(audio.duration);
      });

      // Keep the timeline and timers in sync while playing.
      audio.addEventListener("timeupdate", function () {
        setSeekFill();
        current.textContent = formatTime(audio.currentTime);
        remaining.textContent = "-" + formatTime(audio.duration - audio.currentTime);
      });

      audio.addEventListener("play", function () {
        player.classList.add("is-playing");
        playBtn.setAttribute("aria-label", "Pauzeren");

        // Stop every other player so two tracks never overlap.
        allAudios.forEach(function (other) {
          if (other !== audio && !other.paused) {
            other.pause();
          }
        });
      });

      audio.addEventListener("pause", function () {
        player.classList.remove("is-playing");
        playBtn.setAttribute("aria-label", "Afspelen");
      });

      audio.addEventListener("ended", function () {
        player.classList.remove("is-playing");
        playBtn.setAttribute("aria-label", "Afspelen");
        audio.currentTime = 0;
        setSeekFill();
        current.textContent = formatTime(0);
        remaining.textContent = "-" + formatTime(audio.duration);
      });

      // Play / pause toggle.
      playBtn.addEventListener("click", function () {
        if (audio.paused) {
          audio.play();
        } else {
          audio.pause();
        }
      });

      // Scrubbing the timeline.
      seek.addEventListener("input", function () {
        if (audio.duration) {
          audio.currentTime = (seek.value / 100) * audio.duration;
        }
        seek.style.setProperty("--progress", seek.value + "%");
      });

      // Volume slider.
      volume.addEventListener("input", function () {
        audio.muted = false;
        audio.volume = parseFloat(volume.value);
        player.classList.toggle("is-muted", audio.volume === 0);
        setVolumeFill();
      });

      // Mute toggle.
      muteBtn.addEventListener("click", function () {
        audio.muted = !audio.muted;

        // Un-muting a track that was dragged to zero restores audible volume.
        if (!audio.muted && audio.volume === 0) {
          audio.volume = 1;
        }

        player.classList.toggle("is-muted", audio.muted);
        muteBtn.setAttribute("aria-label", audio.muted ? "Geluid aanzetten" : "Geluid dempen");
        setVolumeFill();
      });

      // Initial state.
      setVolumeFill();
      player.classList.toggle("is-muted", audio.muted || audio.volume === 0);
    });
  } catch (error) {
    // Silent error handling
  }
});
